module.exports = "/work-site/img/wind.a57f57b2.png";